interface ProgressBarBand {
  color: string;
  colorType: "hex" | "class";
  justification?: string;
  outOfScale: boolean;
  percent: number;
  tooltip?: string;
  label?: AdequacyProgressBarLabels | string;
}

enum AdequacyProgressBarLabels {
  MetBothCriteria = "Meets Both Criteria",
  MetOneCriteria = "Meets One of Access or Servicing Criteria",
  MetNoCriteria = "Does Not Meet Any Criteria",
  ApprovedException = "Passes by Exception",
}

export {
  AdequacyProgressBarLabels,
  ProgressBarBand,
};
